<template>
  <div class="auth-wrapper auth-v2">
    <div class="auth-inner">

      <v-row class="auth-row ma-0">
        <v-col
          lg="8"
          class="d-none d-lg-block position-relative overflow-hidden pa-0"
        >
          <div class="auth-illustrator-wrapper">
            <!-- 3d character -->
            <div class="d-flex align-center h-full pa-16 pe-0">
              <v-img
                contain
                max-width="100%"
                height="692"
                class="auth-3d-group"
                :src="require(`@/assets/images/nitron.jpg`)"
              ></v-img>
            </div>
          </div>
        </v-col>

        <v-col
          lg="4"
          class="d-flex align-center auth-bg pa-10 pb-0"
        >
          <v-row>
            <v-col
              cols="12"
              sm="8"
              md="6"
              lg="12"
              class="mx-auto"
            >
              <v-card flat>
                <!-- login form -->
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" lg="12" xl="12" md="12" sm="12" style="text-align: center">
                        <!-- brand logo -->
                        <v-img
                          :src="appLogo"
                          max-height="77px"
                          max-width="150px"
                          alt="logo"
                          class="ma-auto"
                        ></v-img>
                        <!--/ brand logo -->
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-form
                    ref="loginForm"
                    v-model="loginValidation"
                    @submit.prevent="login"
                  >
                    <v-text-field
                      v-model="phoneEmail"
                      outlined
                      dense
                      label="ایمیل / شماره همراه "
                      placeholder="ایمیل / شماره همراه "
                      hide-details="auto"
                      :rules="[v => !!v || 'لطفا شماره همراه خود را وارد نمایید.' , v => (v && v.length >= 13) || 'شماره همراه را مانند 6789 345 0912  وارد نمایید']"
                      class="mb-2 phoneThings"
                      v-mask="'09## ### ####'"

                    ></v-text-field>

                    <v-text-field
                      v-model="code"
                      v-if="resultCodeSituation"
                      outlined
                      dense
                      :type="isCodeVisible ? 'text' : 'password'"
                      label="کد یکبار مصرف را وارد نمایید"
                      placeholder="ورود کد"
                      :rules="[v => !!v || 'این فیلد اجباری است', v => (v && v.length === 6) || 'لطفا 6 رقم وارد نمایید']"
                      :append-icon="isCodeVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                      hide-details="auto"
                      class="mb-2"
                      v-mask="'######'"
                      @click:append="isCodeVisible = !isCodeVisible"
                    ></v-text-field>
                    <v-text-field
                      v-model="password"
                      v-if="resultCodeSituation"
                      outlined
                      dense
                      :type="isPasswordVisible ? 'text' : 'password'"
                      label="پسورد جدید را وارد نمایید"
                      placeholder="ورود پسورد"
                      :rules="[v => !!v || 'این فیلد اجباری است', v => (v && v.length >=8) || 'لطفابیش از 8 جرف وارد نمایید']"
                      :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                      hide-details="auto"
                      class="mb-2"
                      @click:append="isPasswordVisible = !isPasswordVisible"
                    ></v-text-field>
                    <v-text-field
                      v-model="password_confirmation"
                      v-if="resultCodeSituation"
                      dense
                      outlined
                      :type="isPasswordConfirmationVisible ? 'text' : 'password'"
                      label="تکرار رمز عبور"
                      placeholder="تکرار رمز عبور"
                      :append-icon="isPasswordConfirmationVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                      hide-details="auto"
                      class="mb-2"
                      :rules="[v => !!v || 'این فیلد اجباری است', v => (v && v === password) || 'تکرار باید یکسان باشد']"
                      @click:append="isPasswordConfirmationVisible = !isPasswordConfirmationVisible"
                    ></v-text-field>

                    <v-btn
                      block
                      color="primary"
                      type="submit"
                      class="mt-6"
                      v-if="!resultCodeSituation"
                    >
                      درخواست تنظیم مجدد کلمه عبور
                    </v-btn>
                    <v-btn
                      block
                      color="primary"
                      type="success"
                      class="mt-6"
                      v-if="resultCodeSituation && resultCodeSituation"
                    >
                      ثبت پسورد جدید
                    </v-btn>
                  </v-form>
                </v-card-text>

                <!-- create new account  -->
                <v-card-text class="d-flex align-center justify-center flex-wrap mt-2">
                  <router-link to="register">
                    ایجاد حساب کاربری
                  </router-link>
                </v-card-text>

                <!-- divider -->
                <v-card-text class="d-flex align-center mt-2">
                  <v-divider></v-divider>
                  <span class="mx-5">راه های ارتباطی</span>
                  <v-divider></v-divider>
                </v-card-text>

                <!-- socail links -->
                <v-card-actions class="d-flex justify-center">
                  <v-tooltip bottom v-for="link in socialLink" :key="link.icon">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        class="ms-1 mt-0"
                        :href="link.link"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon :color="$vuetify.theme.dark ? link.colorInDark:link.color">
                          {{ link.icon }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ link.tooltip }}</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiFacebook,
  mdiTwitter,
  mdiGithub,
  mdiGoogle,
  mdiEyeOutline,
  mdiEyeOffOutline, mdiTelegram, mdiPhone
} from '@mdi/js'
import axios from '@axios'
import themeConfig from '@themeConfig'
import baseConfig from '@/../baseConfig'
import router from "@/router";
import { mask } from 'vue-the-mask'
import {removeCharFromString} from "@/views/generator/page-handler";

export default {
  directives: { mask },
  data() {
    return {
      loginValidation: false,
      phoneEmail: "",
      code: "",
      password: "",
      password_confirmation: "",
      resultCodeSituation: false,
      isCodeVisible: false,
      isPasswordVisible: false,
      alert: false,
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,
      socialLink: [
        {
          icon: mdiTelegram,
          color: '#4267b2',
          colorInDark: '#4267b2',
          link: 'tg://resolve?domain=mevarizi',
          tooltip: 'کانال اطلاع رسانی',
        },
        {
          icon: mdiTelegram,
          color: '#b424d4',
          colorInDark: '#ba0c9d',
          link: 'tg://resolve?domain=adham54470',
          tooltip: 'ارتباط با مدیریت',
        },
        {
          icon: mdiTelegram,
          color: '#24d42d',
          colorInDark: '#078a23',
          link: 'tg://resolve?domain=Ssupportvarizi',
          tooltip: 'واحد پشتیبانی',
        },
        {
          icon: mdiPhone,
          color: '#24d473',
          colorInDark: '#078a56',
          link: 'tel:5554280940',
          tooltip: 'شماره تماس: 34935-013',
        },
        {
          icon: mdiPhone,
          color: '#511e8c',
          colorInDark: '#3a1064',
          link: 'tel:09115230700',
          tooltip: 'شماره تماس: 09115230700',
        },
        {
          icon: mdiPhone,
          color: '#511e8c',
          colorInDark: '#3a1064',
          link: 'tel:09115230700',
          tooltip: 'شماره تماس: 09117220700',
        },
      ],
    }
  },
  methods: {
    login() {
      this.$refs.loginForm.validate()
      this.alert = true
      try {
        if (this.loginValidation) {
          if (this.resultCodeSituation === false) {
            axios.post(baseConfig.baseUrl + 'getCode', {
              phoneEmail: removeCharFromString(this.phoneEmail, ' ')
            })
              .then(response => {
                console.log(response)
                if (response.data.status === "success") {
                  this.resultCodeSituation = true
                } else {
                  alert("your phone number or email is invalid")
                }
              })
          } else {
            axios.post(baseConfig.baseUrl + 'forgotPassword', {
              phoneEmail: removeCharFromString(this.phoneEmail, ' '),
              code: this.code,
              password: this.password,
              password_confirmation: this.password_confirmation,
            })
              .then(response => {
                if (response.data.status === "success") {
                  alert("کلمه عبور شما با موفقیت تغییر کرد.");
                  this.$router.push('/login')
                } else {
                  this.phoneEmail = ""
                  this.code = ""
                  this.password = ""
                  this.password_confirmation = ""

                  this.resultCodeSituation = false
                  alert("کد احراز هویت شما اشتباه است.")
                }
              })
          }
        }
      }
      catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/pages/auth.scss';
</style>
<style>
.phoneThings input{
  direction: ltr !important;
}
</style>
